import { render, staticRenderFns } from "./currentOnlineSessionsList.vue?vue&type=template&id=8d930876&"
import script from "./currentOnlineSessionsList.vue?vue&type=script&lang=js&"
export * from "./currentOnlineSessionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports